export default function Portfolio() {
  const projects = [
    {
      title: '食品ブランドリニューアル',
      client: '株式会社ナチュラルフーズ',
      category: 'ブランディング',
      year: '2024',
      image: 'https://readdy.ai/api/search-image?query=Natural%20organic%20food%20brand%20illustration%20design%2C%20fresh%20vegetables%20and%20fruits%20artwork%2C%20healthy%20lifestyle%20visual%2C%20warm%20earthy%20color%20palette%2C%20hand-drawn%20style%2C%20artisanal%20aesthetic%2C%20clean%20composition%2C%20simple%20background&width=400&height=600&seq=portfolio001&orientation=portrait'
    },
    {
      title: '児童書シリーズ挿絵',
      client: '光文社出版',
      category: '出版',
      year: '2024',
      image: 'https://readdy.ai/api/search-image?query=Children%20book%20illustration%20artwork%2C%20whimsical%20storybook%20scene%2C%20playful%20characters%2C%20magical%20forest%20setting%2C%20vibrant%20cheerful%20colors%2C%20fairy%20tale%20style%2C%20imaginative%20composition%2C%20simple%20background&width=400&height=600&seq=portfolio002&orientation=portrait'
    },
    {
      title: 'テックスタートアップWebサイト',
      client: 'InnovateTech株式会社',
      category: 'デジタル',
      year: '2023',
      image: 'https://readdy.ai/api/search-image?query=Tech%20startup%20website%20illustration%2C%20modern%20digital%20technology%20concept%2C%20abstract%20geometric%20shapes%2C%20futuristic%20design%20elements%2C%20blue%20and%20purple%20gradient%2C%20innovative%20visual%20style%2C%20clean%20minimal%20background&width=400&height=600&seq=portfolio003&orientation=portrait'
    },
    {
      title: '地域活性化キャンペーン',
      client: '京都市観光協会',
      category: 'マーケティング',
      year: '2023',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20cultural%20tourism%20campaign%20illustration%2C%20traditional%20architecture%20and%20modern%20elements%20blend%2C%20Kyoto%20cityscape%20artwork%2C%20elegant%20Japanese%20aesthetic%2C%20red%20and%20gold%20accents%2C%20artistic%20composition%2C%20simple%20background&width=400&height=600&seq=portfolio004&orientation=portrait'
    },
    {
      title: '教育アプリキャラクター',
      client: 'エデュケーションラボ',
      category: 'キャラクター',
      year: '2024',
      image: 'https://readdy.ai/api/search-image?query=Educational%20app%20character%20design%2C%20friendly%20learning%20mascot%2C%20cute%20animal%20character%2C%20approachable%20personality%2C%20bright%20cheerful%20colors%2C%20child-friendly%20illustration%20style%2C%20simple%20clean%20background&width=400&height=600&seq=portfolio005&orientation=portrait'
    },
    {
      title: 'オーガニックコスメパッケージ',
      client: 'ボタニカルビューティー',
      category: 'パッケージ',
      year: '2023',
      image: 'https://readdy.ai/api/search-image?query=Organic%20cosmetics%20package%20illustration%2C%20botanical%20floral%20pattern%20design%2C%20natural%20beauty%20product%20visual%2C%20elegant%20feminine%20aesthetic%2C%20soft%20pastel%20colors%2C%20delicate%20artwork%2C%20simple%20background&width=400&height=600&seq=portfolio006&orientation=portrait'
    },
    {
      title: '企業周年記念ビジュアル',
      client: '山田商事株式会社',
      category: 'ブランディング',
      year: '2024',
      image: 'https://readdy.ai/api/search-image?query=Corporate%20anniversary%20celebration%20illustration%2C%20business%20milestone%20visual%20design%2C%20professional%20elegant%20artwork%2C%20gold%20and%20navy%20color%20scheme%2C%20commemorative%20graphic%20style%2C%20sophisticated%20composition%2C%20simple%20background&width=400&height=600&seq=portfolio007&orientation=portrait'
    },
    {
      title: 'ライフスタイル雑誌連載',
      client: 'モダンリビング編集部',
      category: '出版',
      year: '2023',
      image: 'https://readdy.ai/api/search-image?query=Lifestyle%20magazine%20editorial%20illustration%2C%20modern%20interior%20design%20scene%2C%20contemporary%20living%20space%20artwork%2C%20stylish%20home%20decor%20visual%2C%20sophisticated%20color%20palette%2C%20artistic%20composition%2C%20simple%20background&width=400&height=600&seq=portfolio008&orientation=portrait'
    }
  ];

  return (
    <section id="portfolio" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="flex items-end justify-between mb-12">
          <div>
            <h2 className="text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
              制作実績
            </h2>
          </div>
          <div className="max-w-xl">
            <p className="text-lg text-gray-600 leading-relaxed">
              多様な業界のクライアント様と共に、数多くのプロジェクトを成功に導いてきました。<br />
              それぞれの案件で培った経験と技術が、次のプロジェクトの品質を支えています。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {projects.map((project, index) => (
            <div 
              key={index}
              className="group relative rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-96 overflow-hidden">
                <img 
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
                
                <div className="absolute top-4 right-4">
                  <span className="px-3 py-1 bg-white/90 backdrop-blur-sm text-xs font-medium text-gray-900 rounded-full">
                    {project.year}
                  </span>
                </div>
                
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <p className="text-xs text-gray-300 mb-2">{project.client}</p>
                  <h3 className="text-xl font-bold text-white mb-2" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                    {project.title}
                  </h3>
                  <span className="inline-block px-3 py-1 bg-rose-600 text-white text-xs font-medium rounded-full">
                    {project.category}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a href="#contact" className="inline-flex items-center gap-2 px-8 py-4 bg-gray-900 text-white text-base font-medium rounded-lg hover:bg-gray-800 transition-all hover:shadow-lg whitespace-nowrap cursor-pointer">
            すべての実績を見る
            <i className="ri-arrow-right-line text-xl"></i>
          </a>
        </div>
      </div>
    </section>
  );
}